import { BrowserRouter, Route, Routes } from "react-router-dom";
import { EditorPage } from "./pages/editor-page";
import { HomePage } from "./pages/home-page";
import { HostPage } from "./pages/host-page";
import { CoHostEntryPage } from "./pages/link-page";
import { ParticipantPage } from "./pages/participant-page";
import { StreamPage } from "./pages/stream-page";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/editor/:quizId" element={<EditorPage />} />
        <Route path="/host/:roomId" element={<HostPage />} />
        <Route path="/control/:roomId" element={<HostPage role="cohost" />} />
        <Route path="/cohost/:linkId" element={<CoHostEntryPage />} />
        <Route path="/play/:roomId" element={<ParticipantPage />} />
        <Route path="/stream/:linkId" element={<StreamPage />} />
      </Routes>
    </BrowserRouter>
  );
}

